
import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import SparkleCard from "../../components/SparkleCard";
import { ContactCardData2 } from "../../Data/AppData";
import dayjs from "dayjs";
import "dayjs/locale/th"; // นำเข้า locale เพิ่มเติม
import "dayjs/locale/lo";
import Apiauth from "../../api/Apiauth";
import { showToast } from "../../utils";
import { handleCheckError } from "../../utils/fetchData";
import { Card, DatePicker, Divider, Empty } from "antd"; // เพิ่ม Col, Row เพื่อความสวยงาม
import { CalendarOutlined, HistoryOutlined, FilterOutlined } from "@ant-design/icons";
import i18next from "i18next";
import localeTH from "antd/es/date-picker/locale/th_TH";
import localeEN from "antd/es/date-picker/locale/en_US";
import LogAccountBalance from "./LogAccountBalance";
import UpdateDataByRoute from "../../helpers/isUpdateDataByRoute";

const dateFormat = "YYYY-MM-DD";
const { RangePicker } = DatePicker;

class Dashbord extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardData: [],
      loading: false,
      spinning: false,
      reportData: [],
      logAccountBalanceData: [],
      isMobile: window.innerWidth <= 768,
      tableParams: {
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        filters: {
          startDate: dayjs().endOf("day"),
          endDate: dayjs().endOf("day"),
        },
        sortField: null,
        sortOrder: null,
      },
      message: "",
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    // เรียก fetch ข้อมูลทันทีเมื่อ mount
    this.fetchReportData();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  fetchReportData = async () => {
    const { tableParams } = this.state;
    const { startDate, endDate } = tableParams.filters;
    const { merchantId } = this.props;

    this.setState({ loading: true, spinning: true });

    const raw = JSON.stringify({
      startDate: startDate ? startDate.format(dateFormat) : dayjs().format(dateFormat),
      endDate: endDate ? endDate.format(dateFormat) : dayjs().format(dateFormat),
      type: "date",
      merchantId: merchantId, // ป้องกัน error ถ้าไม่มี id
    });

    try {
      const response = await Apiauth.postOverviewReportChart(raw);
      if (response.data?.success) {
        const reportData = response.data?.data;
        const contactCardData = ContactCardData2(reportData);
        this.setState({
          reportData: reportData,
          cardData: contactCardData,
          message: response.data?.message,
          loading: false,
          spinning: false,
        }, async () => await this.fetchLogAccountBalanceData());
      } else {
        showToast("error", response.data?.message || "Failed to fetch report data.");
        this.setState({ loading: false, spinning: false });
      }
    } catch (error) {
      console.error("Error fetching report data:", error);
      handleCheckError(error, "");
      this.setState({ loading: false, spinning: false });
    }
  };

  fetchLogAccountBalanceData = async () => {
    const { tableParams } = this.state;
    const { startDate, endDate } = tableParams.filters;
    const { merchantId } = this.props;

    this.setState({ loading: true, spinning: true });

    const raw = JSON.stringify({
      startDate: startDate ? startDate.format(dateFormat) : dayjs().format(dateFormat),
      endDate: endDate ? endDate.format(dateFormat) : dayjs().format(dateFormat),
      page: 1,
      limit: 100,
      merchantId: merchantId, // ป้องกัน error ถ้าไม่มี id
    });

    try {
      const response = await Apiauth.getBankAccountBalanceLogs(raw);
      if (response.data?.success) {
        const reportData = response.data?.data;
        this.setState({
          logAccountBalanceData: reportData,
          loading: false,
          spinning: false,
        });
      } else {
        showToast("error", response.data?.message || "Failed to fetch report data.");
        this.setState({ loading: false, spinning: false });
      }
    } catch (error) {
      console.error("Error fetching report data:", error);
      handleCheckError(error, "");
      this.setState({ loading: false, spinning: false });
    }
  };
  // แก้ไข: รับค่า dates และนำมา update state
  handleDateRangeChange = (dates) => {
    if (!dates) return;

    this.setState(
      (prevState) => ({
        tableParams: {
          ...prevState.tableParams,
          filters: { startDate: dates[0], endDate: dates[1] }
        },
      }),
      () => {
        this.fetchReportData()
      },
    );

  };

  getAntdLocale = () => {
    const currentLanguage = i18next.language;
    if (currentLanguage === "th" || currentLanguage === "lao") return localeTH;
    return localeEN;
  };

  disabledDate = (current) => {
    if (!current) return false;

    // 1. ห้ามเลือกวันที่ในอนาคต (หลังจากวันนี้)
    const isAfterToday = current.isAfter(dayjs().endOf('day'));

    // 2. ห้ามเลือกวันที่เก่ากว่า 60 วันที่แล้ว
    const sixtyDaysAgo = dayjs().subtract(60, 'days').startOf('day');
    const isBefore60Days = current.isBefore(sixtyDaysAgo);

    return isAfterToday || isBefore60Days;
  };

  onUpdateAuto = async () => {
    const { key } = this.props;

    if (!key) {
      this.setState({ loading: false }, () => {
        this.fetchLogAccountBalanceData();
      });
    } else {
      console.log("No update needed for key:", key);
    }
  };
  render() {
    // ดึงค่าจาก state และ props ให้ครบถ้วน
    const { cardData, loading, isMobile, tableParams,  logAccountBalanceData } = this.state;
    const { t, canViewDailySummaryPastTotals } = this.props;
    let { startDate, endDate, } = tableParams.filters;


    const antdLocale = this.getAntdLocale();
    const currentLanguage = i18next.language;
    dayjs.locale(currentLanguage === "lao" ? "lo" : currentLanguage);

    const iconDate = (
      <span>
        <FilterOutlined style={{ marginRight: "5px", color: "rgb(90 90 90)" }} />
        {t("Date")} :
      </span>
    );

    const iconCalendar = <CalendarOutlined style={{ color: "rgb(90 90 90)" }} />;

    return (
      <div className="dashboard-container">
        <UpdateDataByRoute onUpdateAuto={this.onUpdateAuto} />

        <Card
          className="card-report"
          bordered={false}
          style={{ background: "none", boxShadow: "none", border: "none" }}
          title={<Divider orientation={"start"} className="sm-hiden fs-sm-12 mb-3">{iconCalendar} {t("Summary", { startDate: startDate ? startDate.format(dateFormat) : dayjs().format(dateFormat), endDate: endDate ? endDate.format(dateFormat) : dayjs().format(dateFormat) })}</Divider>} // เพิ่ม Title ให้ดูเป็นระเบียบ
          extra={
            canViewDailySummaryPastTotals && (
              <div className="d-flex align-items-start" style={{ flexWrap: "wrap", gap: "10px" }}>
                <RangePicker
                  presets={!isMobile ? [
                    { label: t("7 วันที่ผ่านมา"), value: [dayjs().subtract(7, "d"), dayjs()] },
                    { label: t("14 วันที่ผ่านมา"), value: [dayjs().subtract(14, "d"), dayjs()] },
                    { label: t("30 วันที่ผ่านมา"), value: [dayjs().subtract(30, "d"), dayjs()] },
                    { label: t("60 วันที่ผ่านมา"), value: [dayjs().subtract(60, "d"), dayjs()] },
                  ] : false}
                  prefix={iconDate}
                  showTime={isMobile ? { format: "HH:mm" } : false}
                  disabledDate={this.disabledDate}
                  locale={antdLocale}
                  suffixIcon={iconCalendar}
                  format={dateFormat}
                  value={[startDate, endDate]}
                  renderExtraFooter={() => {
                    return (<><span className="d-block text-danger fs-12 fs-sm-10">* {t("transaction_history_note")}</span></>)
                  }}
                  onChange={this.handleDateRangeChange} // แก้ไขการส่ง function
                  className="mb-3"
                />
              </div>
            )
          }
        >

          {cardData && cardData.length > 0 ? (
            <div className="row">
              {cardData.map((data, i) => (
                <div key={i} className="col-lg-3 col-md-6 col-sm-12 mb-3">
                  <SparkleCard
                    index={i}
                    Heading={t(data?.heading)}
                    Money={Intl.NumberFormat().format(parseFloat(data?.money || 0).toFixed(2))}
                    Icon={data?.icon}
                    Color={data?.color}
                    loading={loading}
                    PerText={t(data?.perText)}
                    chartColor={data?.sparklineData?.areaStyle?.color}
                    mainData={[]}
                    isRandomUpdate={false}
                  />
                </div>
              ))}
            </div>
          ) : (
            <Empty description={t("No data")} />
          )}
        </Card>
        <Divider style={{ fontWeight: "600" }} orientation="start" plain>
          <HistoryOutlined style={{ fontSize: 15 }} /> Log account balance ({logAccountBalanceData?.length}  {t("Entries")})  : {t("Date")} {startDate ? startDate.format(dateFormat) : dayjs().format(dateFormat)} - {endDate ? endDate.format(dateFormat) : dayjs().format(dateFormat)}
        </Divider>
        <div className={`mt-3`} >
          <LogAccountBalance
            loading={loading}
            merchantId={this.props.merchantId}
            tFormat={this.props.tFormat}
            startDate={startDate ? startDate.format(dateFormat) : dayjs().format(dateFormat)}
            endDate={endDate ? endDate.format(dateFormat) : dayjs().format(dateFormat)}
            data={logAccountBalanceData}
            t={t}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isInbox: state.mailInboxReducer.isInbox,
});

export default connect(mapStateToProps, {})(withTranslation()(Dashbord));